import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import { useNavigate } from '@reach/router';
import ArticleCard from './ArticleCard';
import './recentArticles.scss';
import '../pages/index.scss';
import { AllStrapiArticleEdges } from '../data/StrapiArticle';

interface Props {
  title: string;
  showMoreButton?: boolean;
  indexPage?: boolean;
  showFew?: boolean;
}

const RecentArticles: React.FC<Props> = ({ showMoreButton, title, showFew }) => {
  const push = useNavigate();

  const pushToBlog = () => {
    if (process.env.NODE_ENV === 'development') return push(`/blog#recent-articles`);
    return push(`/fourthact/blog#recent-articles`);
  };

  const data: AllStrapiArticleEdges = useStaticQuery(graphql`
    {
      allStrapiArticles {
        edges {
          node {
            id
            title
            content
            shortDescription
            publishedOn
            bannerCover {
              childImageSharp {
                fluid(maxWidth: 360, maxHeight: 180) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
            fields {
              slug
            }
          }
        }
      }
    }
  `);

  return (
    <div className="recentArticlesContainer">
      <h2 className="alignCenter">{title}</h2>
      <div className="recentArticlesContainerInner">
        {data.allStrapiArticles.edges
          .sort(
            ({ node: { publishedOn: publishedOnA } }, { node: { publishedOn: publishedOnB } }) => {
              // @ts-ignore
              return new Date(publishedOnB) - new Date(publishedOnA);
            },
          )
          .map(({ node: { title, id, shortDescription, bannerCover, fields, publishedOn } }, i) => {
            if (i > 2 && showFew) {
              return null;
            }
            if (!bannerCover?.childImageSharp) {
              return null;
            }
            return (
              <ArticleCard
                key={id}
                title={title}
                body={shortDescription}
                articleUrl={fields.slug}
                imgURL={bannerCover.childImageSharp.fluid}
                date={publishedOn}
              />
            );
          })}
      </div>
      {showMoreButton && (
        <div className="recentArticlesContainerButtonContainer">
          <button onClick={pushToBlog} className="buttonSecondaryTeal">
            Show More
          </button>
        </div>
      )}
    </div>
  );
};

export default RecentArticles;
